import { render, staticRenderFns } from "./memberInfo.vue?vue&type=template&id=6f275ede&scoped=true&"
import script from "./memberInfo.vue?vue&type=script&lang=js&"
export * from "./memberInfo.vue?vue&type=script&lang=js&"
import style0 from "./memberInfo.vue?vue&type=style&index=0&id=6f275ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f275ede",
  null
  
)

export default component.exports